import { useContext } from 'react'

import { shallowEqual, useSelector } from 'react-redux'

import AnalyticsPostCampaignReportListViewProfile from '@components/Analytics/PostCampaignReport/ListView/Profile/Profile'
import { getBackgroundColor } from '@components/Analytics/PostCampaignReport/Post/List/List'
import { CampaignContext } from '@context/Campaign'
import { IApplicationState } from '@store'
import { selectXMetricIds } from '@store/postCampaignReport'
import { Container } from '@tribegroup'
import AnalyticsPostCampaignReportListView from '../../ListView/ListView'
import { AnalyticsPostCampaignReportListViewXHeaders } from './Headers'
import { AnalyticsPostCampaignReportXListItem } from './Item'

export const AnalyticsPostCampaignReportXList: React.FC = () => {
  const {
    campaign: { id: campaignId },
  } = useContext(CampaignContext)

  const { submissionIds } = useSelector((state: IApplicationState) => {
    return {
      submissionIds: selectXMetricIds(state, campaignId),
    }
  }, shallowEqual)

  const profiles = submissionIds.map((submissionId, index) => (
    <Container data-testid="x-profile-wrapper" key={`profile-${submissionId}`}>
      <AnalyticsPostCampaignReportListViewProfile
        backgroundColor={getBackgroundColor(index)}
        submissionId={submissionId}
      />
    </Container>
  ))

  return (
    <AnalyticsPostCampaignReportListView
      profiles={profiles}
      headers={<AnalyticsPostCampaignReportListViewXHeaders />}
    >
      {submissionIds.map((submissionId, index) => (
        <Container key={`x-list-${submissionId}`} data-testid="x-list-item">
          <AnalyticsPostCampaignReportXListItem
            submissionId={submissionId}
            backgroundColor={getBackgroundColor(index)}
          />
        </Container>
      ))}
    </AnalyticsPostCampaignReportListView>
  )
}
